import React from 'react';

const DEFAULT_IGNORE_CLASSES = [
  'show-rooms',
  'select-custom__menu-portal',
  'fa-user',
  'fa-circle-info',
  'open',
];

export function useClickAway(cb: () => void, ignoreClasses: string[] = []) {
  const ref = React.useRef(null);
  const refCb = React.useRef(cb);
  const ignoreClassesRef = React.useRef(ignoreClasses);

  React.useLayoutEffect(() => {
    refCb.current = cb;
    ignoreClassesRef.current = ignoreClasses;
  });

  React.useEffect(() => {
    const handler = (e: MouseEvent | TouchEvent) => {
      const element = ref.current as HTMLElement | null;
      const mergedIgnoreClasses = [...DEFAULT_IGNORE_CLASSES, ...ignoreClassesRef.current];
      const hasIgnoredClass = mergedIgnoreClasses.some((className) =>
        (e.target as Element)?.closest(`.${className}`),
      );

      if (element && !element.contains(e.target as Node) && !hasIgnoredClass) {
        setTimeout(() => {
          refCb.current();
        }, 100);
      }
    };

    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);

    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, []);

  return ref;
}
